import { api, config } from '../../../helpers/api';
import { generatePath } from 'react-router-dom';

export async function getUserProfileRequest(id) {
  return await api.get(generatePath('/user/:id', { id }), config('json'));
}

export async function getUserRate() {
  return await api.get(generatePath('/users_rate/implemented'), config('json'));
}

export async function postUserRate({ rate, recieverId }) {
  return await api.post(
    generatePath('/users_rate/'),
    {
      rate: rate,
      receiver_id: recieverId,
      type: 'about_me'
    },
    config('json')
  );
}
